<main class="editor-page">
  <header class="editor-header">
    <button mat-icon-button type="button" (click)="back()" aria-label="Вернуться к новостям"><mat-icon>arrow_back</mat-icon></button>
    <div>
      <p class="eyebrow">Контент B2C</p>
      <h1>{{ news ? 'Редактирование новости' : 'Новая новость' }}</h1>
      <p>Заполните содержание и подготовьте изображение для карусели на главной.</p>
    </div>
  </header>

  <div class="loading" *ngIf="loading"><mat-spinner [diameter]="32"></mat-spinner> Загружаем новость…</div>

  <form *ngIf="!loading" [formGroup]="newsForm" (ngSubmit)="save()" class="editor-grid">
    <section class="panel content-panel">
      <div class="panel-heading"><span class="step">1</span><div><h2>Содержание</h2><p>Этот текст увидят клиенты на главной странице.</p></div></div>

      <mat-form-field appearance="outline">
        <mat-label>Заголовок</mat-label>
        <input matInput formControlName="title" maxlength="255" placeholder="Например, Бесплатная доставка в июле" />
        <mat-hint align="end">{{ newsForm.value.title?.length || 0 }}/255</mat-hint>
        <mat-error>Укажите заголовок</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="text-field">
        <mat-label>Текст новости</mat-label>
        <textarea matInput formControlName="text" rows="10" placeholder="Расскажите клиентам о предложении или изменении"></textarea>
        <mat-error>Добавьте текст новости</mat-error>
      </mat-form-field>

      <div class="publish-row">
        <div><strong>Опубликовать на сайте</strong><span>{{ newsForm.value.active ? 'Новость будет доступна клиентам' : 'Сохранится как черновик' }}</span></div>
        <mat-checkbox formControlName="active" aria-label="Опубликовать новость"></mat-checkbox>
      </div>
    </section>

    <aside class="side-column">
      <section class="panel">
        <div class="panel-heading"><span class="step">2</span><div><h2>Изображение</h2><p>Загрузите своё или создайте по содержанию новости.</p></div></div>
        <input #fileInput hidden type="file" accept="image/*" (change)="handleFileSelect($event)" />
        <div class="image-box" [class.image-box--filled]="img">
          <img *ngIf="img" [src]="img" alt="Изображение новости" />
          <div *ngIf="!img" class="image-placeholder"><mat-icon>image</mat-icon><strong>Изображение не выбрано</strong><span>Рекомендуемый формат — горизонтальный</span></div>
        </div>
        <div class="image-actions">
          <button mat-stroked-button type="button" (click)="loadImg()" [disabled]="uploading || generating"><mat-icon>upload</mat-icon>{{ uploading ? 'Загрузка…' : img ? 'Заменить файл' : 'Загрузить файл' }}</button>
          <button mat-flat-button color="primary" type="button" (click)="generateImage()" [disabled]="generating || uploading"><mat-icon>auto_awesome</mat-icon>{{ generating ? 'Генерация…' : img ? 'Создать другой вариант' : 'Создать с ИИ' }}</button>
        </div>
        <p class="ai-note"><mat-icon>info_outline</mat-icon>ИИ использует заголовок и текст. Проверьте результат перед публикацией.</p>
      </section>

      <section class="panel preview-panel">
        <div class="preview-title"><h2>Предпросмотр карусели</h2><span>Desktop</span></div>
        <div class="carousel-preview" [style.background-image]="img ? 'linear-gradient(90deg, rgba(14,25,42,.92), rgba(14,25,42,.3)), url(' + img + ')' : ''">
          <div><small>Новости Автофорвард</small><h3>{{ newsForm.value.title || 'Заголовок новости' }}</h3><p>{{ newsForm.value.text || 'Краткий текст новости будет отображаться здесь.' }}</p></div>
          <span class="dots">● ○ ○</span>
        </div>
      </section>
    </aside>

    <footer class="editor-actions">
      <button mat-button type="button" (click)="back()">Отмена</button>
      <button mat-flat-button color="primary" type="submit" [disabled]="saving || uploading || generating"><mat-icon>save</mat-icon>{{ saving ? 'Сохранение…' : news ? 'Сохранить изменения' : 'Создать новость' }}</button>
    </footer>
  </form>
</main>
